import { Observable } from 'rxjs';
import { IApiResponse } from '@web/shared-types';
import { AppConfigService } from '../../../app-config.service';
import { inject } from '@angular/core';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { IGetGateway } from '../../gateways';
import { ITariffRelationLocation } from '@web/dtos';

export interface IOriginRequest {
  loadAllStops: boolean;
  serviceAreaId: number;
  maxResults: number;
  name?: string;
}

export class OriginsGateway implements IGetGateway<
  IOriginRequest,
  IApiResponse<ITariffRelationLocation[]>
> {
  private readonly restCallBuilder: RestCallBuilder<ITariffRelationLocation[]> =
    new RestCallBuilder<ITariffRelationLocation[]>([]);
  private readonly configService: AppConfigService = inject(AppConfigService);

  get(
    request: IOriginRequest
  ): Observable<IApiResponse<ITariffRelationLocation[]>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.tariffUrl + '/relation/origins/',
        {
          serviceAreaId: request.serviceAreaId,
          maxResults: request.loadAllStops ? '' : request.maxResults,
          name: request.name || '',
        }
      )
      .handleMessages()
      .build();
  }
}
